import { React } from '../../libraries';

export const ThumbnailContentComponent = (props) => {
    const { 
        image, 
        altImage, 
        width, 
        title, 
        description, 
        displayType, 
        display, 
        font_color_thumbnail, 
        background_color_thumbnail 
    } = props;

    const handleCounterChange = (newValue) => {
        props.onChangeCounter(true+","+newValue);
    }

    let display1 = null;
    let display2 = null;
    let display3 = null;
    let display4 = null;

    display1 = (<div className={`display-1 text-center pr-3 mb-3 xl:mb-10 xl:flex-1 ${width}`}>
        <div style={{color: font_color_thumbnail, backgroundColor: background_color_thumbnail}} className="h-full rounded sm:px-4 px-1 pb-4">
            {image && <img src={image} alt={altImage} className="sm:object-scale-down sm:w-full w-4/5 mx-auto xl:h-50 sm:h-40 mb-0" />}
            <p className="font-bold sm:text-md text-sm sm:mb-3 mb-1">{title}</p>
            <p className="xl:text-sm text-xs">{description}</p>
        </div>
    </div>);

    display2 = (<div className={'display-2 xl:px-4 xl:mb-10 pr-3 mb-3 ' + width}>
        <div 
            style={{color: font_color_thumbnail, backgroundColor: background_color_thumbnail}} 
            className="flex flex-col xl:px-10 px-2 sm:py-5 py-3 w-full xl:h-auto h-full border-solid border-2 rounded border-gray-200">
            <img src={image} alt={altImage} className="sm:object-scale-down sm:w-full w-3/5 mx-auto lg:h-24 sm:h-20 lg:mb-6 sm:mb-4 mb-2 lg:mt-5 sm:mt-3 mt-2" />
            <div className="w-full text-center">
                <p className="font-bold sm:text-md text-sm sm:mb-3 mb-1">{title}</p>
                <p className="xl:text-sm text-xs">{description}</p>
            </div>
        </div>
    </div>)

    display3 = (<div className={'display-3 xl:px-2 xl:mb-10 pr-3 mb-3 ' + width}>
        <div 
            style={{color: font_color_thumbnail, backgroundColor: background_color_thumbnail}} 
            className="flex items-center px-2 py-2 w-full rounded border-solid border-2 border-gray-200 xl:h-auto h-full">
            <img src={image} alt={altImage} className="rounded object-scale-down xl:w-2/4 w-1/5" />
            <div className="pl-2 xl:w-2/4 w-4/5">
                <p className="font-bold text-md xl:mb-3 text-sm">{title}</p>
                <p className="text-sm">{description}</p>
            </div>
        </div>
    </div>)

    display4 = (<div className={'display-4 text-center xl:px-2 xl:mb-10 pr-3 mb-3 ' + width} id={displayType}>
        <div 
            style={{color: font_color_thumbnail, backgroundColor: background_color_thumbnail}} 
            className="flex flex-col xl:px-10 xl:py-5 py-6 sm:px-3 px-1 w-full rounded border-solid border-2 border-gray-200">
            {/* {image && <img src={image} alt={alt} className="object-scale-down w-full h-48 mb-5" />} */}
            <div className="w-full text-center">
                <p className="font-bold md:text-xl sm:text-lg text-sm md:mb-5 sm:mb-3 mb-1">{title}</p>
                <p className="md:text-lg sm:text-md text-xs">{description}</p>
                {(display.is_button) ? <button className="lg:mt-24 md:mt-16 sm:mt-12 mt-6 bg-green-500 py-2 md:px-10 sm:px-6 px-6 text-white lg:text-lg sm:text-md text-xs rounded" onClick={(value) => {handleCounterChange(title)}}>Daftar</button> : ""}
            </div>
        </div>
    </div >)


    return (
        <>
            {displayType && displayType === "0" ? display1 : ""}
            {displayType && displayType === "1" ? display2 : ""}
            {displayType && displayType === "2" ? display3 : ""}
            {displayType && displayType === "3" ? display4 : ""}
        </>
    );
}

ThumbnailContentComponent.defaultProps = {
    image: 'https://dummyimage.com/250x200/faedfa/c7c9ed.png&text=images',
    altImage: 'Image Default',
    width: 'w-1/2 md:w-2/6',
    title: 'Cocok untuk Usaha Mikro Maupun Makro',
    description: 'Dapat digunakan untuk beberapa jenis usaha Anda, antara lain : Ritel & restaurant, Petshop dan Salon.',
    // displayType: "1"
}